import React, { Fragment, useContext, useEffect, useState } from "react";
import styles from "./Step.module.css";
import StepsHeader from "../../../Components/StepsHeader/StepsHeader";
import Hot from "../../../assets/componentAssets/Hot.png";
import info from "../../../assets/componentAssets/info.svg";
import {
  Button,
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputAdornment,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
} from "@mui/material";
import DateField from "../../../Components/DateField/DateField";
import NavButton from "./NavButton";
import { AppContext } from "../../../ContextApi/AppContext/AppContext";
import { PatchApi, getApi } from "../../../Utility/network";
import {
  atticTypes,
  belowGroundFloor,
  booleanValue,
  celingConstructionType,
  clearId,
  degreeArr,
  heatedPercent,
  insulationFields,
  monthYear,
  structure_type,
} from "../utility/utils";
import {
  indexToAlphabet,
  selectedLanguage,
  zdate,
} from "../../../Utility/helper";
import PopUpInfo from "../../../Components/PopUpInfo/PopUpInfo";
import { errorMessage } from "../../../Utility/constants";
import buildingComponent from "../../../assets/dashboard/buildingComponent.svg";
import BuildingTabs from "../BuildingTabs/BuildingTabs";
import CustomCheckBox from "../../../Components/CustomCheckBox/CustomCheckBox";
import CustomInput from "../../../Components/CustomInput/CustomInput";
import {
  arrayId,
  convertCommaToDot,
  convertDotToComma,
  objectId,
  processArray,
  processWindows,
} from "../../../Utility/utils";
let view_count = 0;
function Step3() {
  const { state, setState } = useContext(AppContext);
  const { language, needLanguage } = state;
  const [infoText, setInfoText] = useState([]);
  const [type, setType] = useState(1);
  const [glazingData, setGlazingData] = useState([]);
  const [windows, setWindows] = useState(null);
  const [structure, setStructure] = useState([]);
  const [material, setMaterial] = useState([]);
  const [errorsData, setErrorsData] = useState({ error: "" });
  const [response, setResponse] = useState(false);
  const [errorWindow, setErrorWindow] = useState([]);
  const [disableNext, setDisableNext] = useState(true);
  const [structType, setStructType] = useState(0);
  const [windowsNew, setWindowsNew] = useState({
    structure_type: null,
    wall_details: [],
    window_details: [],
    active: {},
  });

  const [submitData, setSubmitData] = useState({
    ventilation: false,
    insulation: false,
    insulation_details: [],
    what_lies_below_ground_floor: "",
    ceiling_construction: "",
    window_details: [],
    construction: null,
    attic: null,
    roof_height: null,
    is_attic_heated: false,
    roof_pitch: null,
    does_property_have_knee_wall_or_seal: false,
    knee_wall: null,
    heating_percentage: null,
    is_dimension_available_for_every_window: false,
    is_there_second_attic: false,
    is_second_attic_heated: false,

    heating_percentage_of_second_attic: null,
    second_attic_height: null,
    heating_percentage_1: 0,

    ridge_length: null,
    ridge_width: null,

    construction_year: "",
  });
  const { structure_detail } = state?.walls;
  const { structure_type, wall_details } = structure_detail;
  useEffect(() => {
    let window_details = [];
    let is_dimension = false;
    let new_window_details = state?.needData?.window_details?.map(
      (item, index) => {
        const { attached_wall, window_type, ...rest } = item;
        let attached_wall_id = objectId(attached_wall);
        let window_type_id = objectId(window_type);
        if (item.is_dimension_available_for_every_window) {
          return {
            ...rest,
            attached_wall_id,
            window_type_id,
            width:
              language == "de"
                ? convertDotToComma(item.width)
                : convertCommaToDot(item.width),
            length:
              language == "de"
                ? convertDotToComma(item.length)
                : convertCommaToDot(item.length),
          };
        } else {
          return {
            ...rest,
            attached_wall_id,
            window_type_id,
            percentage_of_window_area_on_the_wall:
              language == "de"
                ? convertDotToComma(item.percentage_of_window_area_on_the_wall)
                : convertCommaToDot(item.percentage_of_window_area_on_the_wall),
          };
        }
      }
    );
    if (new_window_details && new_window_details.length > 0) {
      is_dimension =
        new_window_details[0].is_dimension_available_for_every_window;
    }
    window_details = wall_details?.map((item) => ({
      window_type_id: null,
      attached_wall_id: item.id,
      is_dimension_available_for_every_window: is_dimension,
      percentage_of_window_area_on_the_wall: 0,
    }));
    if (new_window_details?.length > 0) {
      window_details = [...window_details, ...new_window_details];
    }
    if (new_window_details && new_window_details.length > 0) {
      let firstObj = new_window_details[0];
      if (!firstObj.is_dimension_available_for_every_window) {
        let data = processArray(window_details);
        window_details = data;
      } else {
        let window_data = [...window_details];
        window_details = processWindows(window_data);
      }
    }

    setWindowsNew((prev) => ({
      ...prev,
      structure_type,
      window_details,
      wall_details,
      active: wall_details && wall_details.length > 0 ? wall_details[0] : {},
    }));
    setStructType(structure_detail.structure_type);
  }, [state.walls.structure_detail, state.needData.window_details]);
  const changeArray = (value) => {
    let window_details = [];

    if (value == false) {
      window_details = Array.from(
        { length: windowsNew?.wall_details.length },
        (v, i) => {
          return {
            window_type_id: null,
            attached_wall_id:
              wall_details && wall_details.length > 0 ? wall_details[0].id : {},
            is_dimension_available_for_every_window: false,
            percentage_of_window_area_on_the_wall: null,
          };
        }
      );
      if (windowsNew?.wall_details?.length !== 0) {
        window_details = windowsNew?.wall_details?.map((item) => ({
          window_type_id: null,
          attached_wall_id: item.id,
          is_dimension_available_for_every_window: false,
          percentage_of_window_area_on_the_wall: 0,
        }));
      }
    } else {
      window_details = windowsNew?.wall_details?.map((item) => ({
        window_type_id: null,
        attached_wall_id: item.id,
        is_dimension_available_for_every_window: true,
        length: null,
        width: null,
        count: null,
      }));
    }
    setWindowsNew((prev) => ({
      ...prev,
      ...(window_details?.length > 0 && { window_details }),
    }));
  };

  // useEffect(() => {
  function updateInsulation(value) {
    if (value == "true" || value == true) {
      setSubmitData((prev) => ({
        ...prev,
        insulation_details: insulationFields,
      }));
    } else {
      setSubmitData((prev) => ({
        ...prev,
        insulation_details: [],
      }));
    }
  }

  // }, [submitData.insulation]);

  const [roof, setRoof] = useState([]);
  const [roofType, setRoofType] = useState({});
  const [pop, setPop] = useState(false);
  function validateFields() {
    const errors = {};
    let hasErrors = false;
    const { id } = roofType;
    const { window_details } = windowsNew;
    const {
      construction,
      attic,
      is_attic_heated,
      roof_pitch,
      roof_height,

      is_dimension_available_for_every_window,

      what_lies_below_ground_floor,
      ceiling_construction,
      heating_percentage,

      insulation,
      insulation_details,
      heating_percentage_1,
      ridge_length,
      ridge_width,

      is_second_attic_heated,
      is_there_second_attic,

      second_attic_height,
      heating_percentage_of_second_attic,

      does_property_have_knee_wall_or_seal,
      knee_wall,
    } = submitData;
    const _data = {
      construction,
      ...(id != 3 && {
        attic,
        is_attic_heated,
        roof_pitch,
        roof_height,
      }),
      ...(id == 5 && {
        attic,
        is_attic_heated,
        roof_pitch,
        roof_height,
        ridge_length,
        ridge_width,
      }),
      ...(is_attic_heated == 1 && { heating_percentage_1 }),

      ...(is_there_second_attic && { second_attic_height }),
      ...(is_there_second_attic &&
        is_second_attic_heated && { heating_percentage_of_second_attic }),

      ...((type === 3 || type === 4) && {
        what_lies_below_ground_floor,
      }),
      ...((type === 3 || type === 4) && {
        ceiling_construction,
      }),
      ...(what_lies_below_ground_floor == 2 &&
        (type === 3 || type === 4) && {
          heating_percentage,
        }),

      ...(does_property_have_knee_wall_or_seal && { knee_wall }),

      insulation_details,

      id,

      window_details,
    };

    for (const key in _data) {
      if (Array.isArray(_data[key])) {
        if (
          key === "window_details" &&
          _data[key].length !== 0 &&
          (type === 2 || type === 4)
        ) {
          const _newData = _data[key];
          const errorData = [];
          if (Array.isArray(_newData)) {
            _newData.forEach((item, idx) => {
              let _item = JSON.stringify(item);
              errorData.push(JSON.parse(_item));
              // if (item.window_type_id !== null) {
              if (submitData.is_dimension_available_for_every_window) {
                if (item.window_type_id !== null) {
                  let hasValue = false;

                  // Check if any of the keys (count, length, width) has a non-empty value
                  if (
                    (item.count && item.count !== "") ||
                    (item.length && item.length !== "") ||
                    (item.width && item.width !== "")
                  ) {
                    hasValue = true;
                  }

                  for (const subKey in item) {
                    errorData[idx][subKey] = ""; // Clear any previous errors for this key

                    // If the item has a value for count, length, or width, we want to check other fields.
                    if (hasValue) {
                      // Check if any field (count, length, width) is missing or empty
                      if (
                        subKey === "window_type_id" &&
                        item[subKey] === null // window_type_id should not be null if any dimension fields are provided
                      ) {
                        errorData[idx][subKey] =
                          needLanguage.required_field_error;
                        hasErrors = true;
                      }

                      // Ensure that all of count, length, and width have values if any of them is provided
                      if (
                        (subKey === "count" ||
                          subKey === "length" ||
                          subKey === "width") &&
                        (item[subKey] === "" || item[subKey] === null)
                      ) {
                        errorData[idx][subKey] =
                          needLanguage.required_field_error;
                        hasErrors = true;
                      }
                    }

                    // Validation for count, length, and width values
                    if (
                      subKey === "count" ||
                      subKey === "length" ||
                      subKey === "width"
                    ) {
                      if (language === "de") {
                        const newValue = convertCommaToDot(item[subKey]); // Convert commas to dots for numeric validation
                        const regex = /^[0-9]+(,[0-9]+)?$/; // Matches numbers with an optional comma for decimals
                        if (
                          !regex.test(item[subKey]) || // Validate format
                          parseFloat(newValue) < 0 // Validate range: must be >= 0
                        ) {
                          errorData[idx][subKey] =
                            needLanguage.required_field_error;
                          hasErrors = true;
                        }
                      } else {
                        const newValue = item[subKey] ? item[subKey] : "";
                        const regex = /^\d+(\.\d+)?$/; // Matches numbers with decimals (dot notation)
                        if (
                          !regex.test(newValue) || // Validate format
                          parseFloat(newValue) < 0 // Validate range: must be >= 0
                        ) {
                          errorData[idx][subKey] =
                            needLanguage.required_field_error;
                          hasErrors = true;
                        }
                      }
                    }
                  }
                }
              } else {
                for (const subKey in item) {
                  errorData[idx][subKey] = "";
                  if (
                    item.window_type_id === null &&
                    item.percentage_of_window_area_on_the_wall > 0
                  ) {
                    errorData[idx].window_type_id =
                      needLanguage.required_field_error;
                    hasErrors = true;
                  }
                  if (subKey === "percentage_of_window_area_on_the_wall") {
                    const newValue = convertCommaToDot(item[subKey].toString()); // Convert commas to dots for numeric validation

                    if (language === "de") {
                      const regex = /^[0-9]+(,[0-9]+)?$/; // Matches numbers with an optional comma for decimals
                      if (
                        !regex.test(item[subKey]) || // Validate format
                        parseFloat(newValue) < 0 || // Validate range: must be >= 0
                        parseFloat(newValue) > 100 // Validate range: must be >= 0
                      ) {
                        errorData[idx][subKey] = needLanguage.percent_error;
                        hasErrors = true;
                      }
                    } else {
                      const newValue = item[subKey].toString();
                      const regex = /^\d+(\.\d+)?$/; // Matches numbers with decimals (dot notation)
                      if (
                        !regex.test(newValue) || // Validate format
                        parseFloat(newValue) < 0 || // Validate range: must be >= 0
                        parseFloat(newValue) > 100 // Validate range: must be >= 0
                      ) {
                        errorData[idx][subKey] = needLanguage.percent_error;
                        hasErrors = true;
                      }
                    }
                  }
                }
              }
              // }
            });
          }
          setErrorWindow(errorData);
        }

        if (key === "insulation_details" && type === 4) {
          errors[key] = Array(4).fill("");
          _data[key].forEach((item, idx) => {
            if (language === "de") {
              const regex = /^[0-9]+(,[0-9]+)?$/; // Matches numbers with an optional comma for decimals
              let newVal = item.length.toString();
              newVal = convertCommaToDot(newVal.toString()); // Convert comma to dot for further validation
              if (
                typeof newVal !== "string" || // Ensure input is a string
                !regex.test(item.length) || // Validate format: digits, optional comma
                parseFloat(newVal) < 0 // Check range: >= 0
              ) {
                errors[key][idx] = needLanguage.valid_number;
                hasErrors = true;
              }
            } else {
              const newVal = item.length.toString(); // Convert comma to dot for further validation
              if (
                typeof newVal !== "string" || // Ensure input is a string
                !/^\d+(\.\d+)?$/.test(newVal) || // Regex to validate numbers and decimals
                parseFloat(newVal) < 0 // Check range: >= 0
              ) {
                errors[key][idx] = needLanguage.valid_number;
                hasErrors = true;
              }
            }
          });
        }
      } else if (
        _data[key] === null ||
        _data[key] === "" ||
        _data[key] === false
      ) {
        errors[key] = needLanguage.required_field_error;
        hasErrors = true;
      } else if (key === "second_attic_height") {
        if (language === "de") {
          const regex = /^[0-9]+(,[0-9]+)?$/; // Matches numbers with an optional comma for decimals
          let newVal = _data[key].toString();
          newVal = convertCommaToDot(newVal.toString()); // Convert comma to dot for further validation
          if (
            typeof newVal !== "string" || // Ensure input is a string
            !regex.test(_data[key]) || // Validate format: digits, optional comma
            parseFloat(newVal) < 0 // Check range: >= 0
          ) {
            errors[key] = needLanguage.valid_number;
            hasErrors = true;
          }
        } else {
          const newVal = _data[key].toString(); // Convert comma to dot for further validation
          if (
            typeof newVal !== "string" || // Ensure input is a string
            !/^\d+(\.\d+)?$/.test(newVal) || // Regex to validate numbers and decimals
            parseFloat(newVal) < 0 // Check range: >= 0
          ) {
            errors[key] = needLanguage.valid_number;
            hasErrors = true;
          }
        }
      } else if (key === "knee_wall") {
        const newValue = convertCommaToDot(_data[key].toString()); // Convert commas to dots for numeric validation

        if (language === "de") {
          const regex = /^[0-9]+(,[0-9]+)?$/; // Matches numbers with an optional comma for decimals
          if (
            !regex.test(_data[key]) || // Validate format
            parseFloat(newValue) < 0 || // Validate range: must be >= 0
            parseFloat(newValue) > 100 // Validate range: must be >= 0
          ) {
            errors[key] = needLanguage.percent_error;
            hasErrors = true;
          }
        } else {
          const newValue = _data[key].toString();
          const regex = /^\d+(\.\d+)?$/; // Matches numbers with decimals (dot notation)
          if (
            !regex.test(newValue) || // Validate format
            parseFloat(newValue) < 0 || // Validate range: must be >= 0
            parseFloat(newValue) > 100 // Validate range: must be >= 0
          ) {
            errors[key] = needLanguage.percent_error;
            hasErrors = true;
          }
        }
      } else if (key === "heating_percentage_of_second_attic") {
        const newValue = convertCommaToDot(_data[key].toString()); // Convert commas to dots for numeric validation

        if (language === "de") {
          const regex = /^[0-9]+(,[0-9]+)?$/; // Matches numbers with an optional comma for decimals
          if (
            !regex.test(_data[key]) || // Validate format
            parseFloat(newValue) < 0 || // Validate range: must be >= 0
            parseFloat(newValue) > 100 // Validate range: must be >= 0
          ) {
            errors[key] = needLanguage.percent_error;
            hasErrors = true;
          }
        } else {
          const newValue = _data[key].toString();
          const regex = /^\d+(\.\d+)?$/; // Matches numbers with decimals (dot notation)
          if (
            !regex.test(newValue) || // Validate format
            parseFloat(newValue) < 0 || // Validate range: must be >= 0
            parseFloat(newValue) > 100 // Validate range: must be >= 0
          ) {
            errors[key] = needLanguage.percent_error;
            hasErrors = true;
          }
        }
      } else if (key === "heating_percentage_1") {
        const newValue = convertCommaToDot(_data[key].toString()); // Convert commas to dots for numeric validation

        if (language === "de") {
          const regex = /^[0-9]+(,[0-9]+)?$/; // Matches numbers with an optional comma for decimals
          if (
            !regex.test(_data[key]) || // Validate format
            parseFloat(newValue) < 0 || // Validate range: must be >= 0
            parseFloat(newValue) > 100 // Validate range: must be >= 0
          ) {
            errors[key] = needLanguage.percent_error;
            hasErrors = true;
          }
        } else {
          const newValue = _data[key].toString();
          const regex = /^\d+(\.\d+)?$/; // Matches numbers with decimals (dot notation)
          if (
            !regex.test(newValue) || // Validate format
            parseFloat(newValue) < 0 || // Validate range: must be >= 0
            parseFloat(newValue) > 100 // Validate range: must be >= 0
          ) {
            errors[key] = needLanguage.percent_error;
            hasErrors = true;
          }
        }
      } else if (
        key === "roof_height" &&
        [1, 2, 4, 5].includes(roofType.id) &&
        (type === 1 || type === 4)
      ) {
        if (language === "de") {
          const regex = /^[0-9]+(,[0-9]+)?$/; // Matches numbers with an optional comma for decimals
          let newVal = _data[key] ? _data[key].toString() : "";
          newVal = convertCommaToDot(newVal.toString()); // Convert comma to dot for further validation
          if (
            typeof newVal !== "string" || // Ensure input is a string
            !regex.test(_data[key]) || // Validate format: digits, optional comma
            parseFloat(newVal) < 0 // Check range: >= 0
          ) {
            errors[key] = needLanguage.valid_number;
            hasErrors = true;
          }
        } else {
          const newVal = _data[key].toString(); // Convert comma to dot for further validation
          if (
            typeof newVal !== "string" || // Ensure input is a string
            !/^\d+(\.\d+)?$/.test(newVal) || // Regex to validate numbers and decimals
            parseFloat(newVal) < 0 // Check range: >= 0
          ) {
            errors[key] = needLanguage.valid_number;
            hasErrors = true;
          }
        }
      } else if (
        [5].includes(roofType.id) &&
        (key === "ridge_length" || key === "ridge_width")
      ) {
        if (language === "de") {
          const regex = /^[0-9]+(,[0-9]+)?$/; // Matches numbers with an optional comma for decimals
          let newVal = _data[key].toString();
          newVal = convertCommaToDot(newVal.toString()); // Convert comma to dot for further validation
          if (
            typeof newVal !== "string" || // Ensure input is a string
            !regex.test(_data[key]) || // Validate format: digits, optional comma
            parseFloat(newVal) < 0 // Check range: >= 0
          ) {
            errors[key] = needLanguage.valid_number;
            hasErrors = true;
          }
        } else {
          const newVal = _data[key].toString(); // Convert comma to dot for further validation
          if (
            typeof newVal !== "string" || // Ensure input is a string
            !/^\d+(\.\d+)?$/.test(newVal) || // Regex to validate numbers and decimals
            parseFloat(newVal) < 0 // Check range: >= 0
          ) {
            errors[key] = needLanguage.valid_number;
            hasErrors = true;
          }
        }
      }
    }
    setErrorsData({
      error: needLanguage.building_component_error,
      ...errors,
    });
    return hasErrors;
  }
  const handleSubmit = async (num, _type) => {
    // "roof_shape_id": 1,

    // "construction": 10,

    // "attic": 1,

    // "is_attic_heated": true,

    // "roof_pitch": 121,

    // "roof_height": 12,

    // "does_property_have_knee_wall_or_seal": true,

    // "knee_wall": 12,

    // "number_of_attics": 1
    try {
      if (_type === "next") {
        var errors;
        if (type === 1) {
          errors = validateFields();
          if (errors) return;
          setType(2);
          return;
        } else if (type === 2) {
          errors = validateFields();
          if (errors) return;
          setType(3);
          return;
        } else if (type === 3) {
          errors = validateFields();
          if (errors) return;
          setType(4);
          return;
        } else if (type === 4) {
          errors = validateFields();
          if (errors) return;
        }

        let filteredData = windowsNew.window_details.filter(
          (item) => item.window_type_id !== null
        );
        var newFilteredData = [];
        if (submitData.is_dimension_available_for_every_window) {
          newFilteredData = filteredData.map((item, index) => {
            return {
              ...item,
              count: convertCommaToDot(item.count.toString()),
              length: convertCommaToDot(item.length.toString()),
              width: convertCommaToDot(item.width.toString()),
            };
          });
        } else {
          newFilteredData = filteredData.map((item, index) => {
            return {
              ...item,
              percentage_of_window_area_on_the_wall: convertCommaToDot(
                item.percentage_of_window_area_on_the_wall.toString()
              ),
            };
          });
        }

        const {
          construction,
          attic,
          is_attic_heated,
          roof_pitch,
          roof_height,
          does_property_have_knee_wall_or_seal,
          knee_wall,
          window_details,
          what_lies_below_ground_floor,
          ceiling_construction,
          insulation_details,
          is_there_second_attic,
          is_second_attic_heated,
          heating_percentage_of_second_attic,
          second_attic_height,
          heating_percentage,
          heating_percentage_1,
          ridge_length,
          ridge_width,
          insulation,
        } = submitData;

        let newInsulation = insulation_details.map((item, index) => {
          return { ...item, length: convertCommaToDot(item.length.toString()) };
        });
        const _data = {
          is_insulated: insulation,
          roof_detail: {
            roof_shape_id: roofType?.id,
            construction: construction,
            attic: attic,
            is_attic_heated: is_attic_heated == 1 ? true : false,
            roof_pitch: roof_pitch,
            ...(roofType?.id != 3 && {
              roof_height: convertCommaToDot(roof_height ? roof_height : null),
            }),
            does_property_have_knee_wall_or_seal:
              does_property_have_knee_wall_or_seal,
            ...(knee_wall && {
              knee_wall: convertCommaToDot(knee_wall.toString()),
            }),
            number_of_attics: is_there_second_attic ? 2 : 1,
            is_there_second_attic,
            is_second_attic_heated,
            ...(roofType?.id == 1 &&
              heating_percentage_of_second_attic &&
              is_second_attic_heated && {
                heating_percentage_of_second_attic: convertCommaToDot(
                  heating_percentage_of_second_attic
                ),
              }),
            ...(roofType?.id == 1 &&
              second_attic_height && {
                second_attic_height: convertCommaToDot(
                  second_attic_height.toString()
                ),
              }),
            ...(is_attic_heated == 1 && {
              heating_percentage: heating_percentage_1,
            }),
            ...(roofType?.id == 5 && {
              ridge_length: convertCommaToDot(ridge_length.toString()),
            }),
            ...(roofType?.id == 5 && {
              ridge_width: convertCommaToDot(ridge_width.toString()),
            }),
          },
          window_details: newFilteredData,
          insulation_details: newInsulation,

          basement_detail: {
            what_lies_below_ground_floor: what_lies_below_ground_floor,
            ceiling_construction: ceiling_construction,
            ...(what_lies_below_ground_floor == 2 && {
              heating_percentage: heating_percentage,
            }),
          },
          language: language === "de" ? 2 : 1,
        };
        if (type !== 4) return;
        try {
          const postData = await PatchApi(`/energy_need/${state.needId}/`, {
            ..._data,
          });
          if (postData.status === 200 || postData.status === 201) {
            const {
              basement_detail,
              insulation_details,
              roof_detail,
              window_details,
            } = postData.data.data;
            setState((prev) => ({
              ...prev,
              needPage: 4,
              needData: {
                ...prev.needData,
                basement_detail,
                insulation_details,
                roof_detail,
                window_details,
                insulation: submitData.insulation,
                active: windowsNew.active,
                construction_year: submitData.construction_year,
                windowDimension:
                  submitData.is_dimension_available_for_every_window,
              },
              needFilledPage:
                prev.needFilledPage >= 4 ? prev.needFilledPage : 4,
            }));
          } else {
            throw Error("api failed");
          }
        } catch (error) {
          console.error("An error occurred:", error);
        }
      } else if (_type === "prev") {
        if (type === 1) {
          setState((prev) => ({ ...prev, needPage: prev.needPage - 1 }));
          return;
        } else if (type === 2) {
          setType(1);
          return;
        } else if (type === 3) {
          setType(2);
          return;
        } else if (type === 4) {
          setType(3);
        }
      } else if (_type === "save") {
        await getApi(`/energy_need/${state.needId}/generate_link/`);
        // navigate("/login");
        setResponse(true);
      }
    } catch (error) {
      console.log(error, "hello error");
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (
      name === "is_dimension_available_for_every_window" ||
      name == "is_second_attic_heated" ||
      name == "insulation" ||
      name == "is_there_second_attic" ||
      name == "does_property_have_knee_wall_or_seal"
    ) {
      setSubmitData((prev) => ({
        ...prev,
        [name]: value == "true" ? true : false,
      }));
      if (name === "is_dimension_available_for_every_window") {
        changeArray(value == "true" ? true : false);
      }
      if (name === "insulation") {
        updateInsulation(value);
      }
    } else {
      if (name === "construction_year") {
        const windowData = [...windowsNew.window_details];
        const _data = clearId(windowData, "window_type_id");
        setWindowsNew((prev) => ({ ...prev, window_details: _data }));
      }
      setSubmitData((prev) => ({ ...prev, [name]: value }));
    }
  };
  const handleChangeIndex = (e, index) => {
    const { name, value } = e.target;
    setSubmitData((prev) => {
      const _data = prev.window_details;
      _data[index][name] = value;

      return { ...prev, window_details: _data };
    });
  };
  const handleChangeInsulation = (e, index) => {
    const { name, value } = e.target;
    setSubmitData((prevData) => {
      // Make a copy of the previous state
      const newData = [...prevData["insulation_details"]];
      // Update the specific field of the object at the given index
      newData[index] = { ...newData[index], [name]: value };
      return { ...prevData, insulation_details: newData }; // Return the updated array
    });
  };
  useEffect(() => {
    getData();
    window.scroll(0, 0);
  }, []);
  useEffect(() => {
    const { construction_year } = submitData;
    if (
      construction_year > 1850 &&
      construction_year <= new Date().getFullYear()
    ) {
      getSelectData(construction_year);
    }
  }, [submitData]);
  const getSelectData = async () => {
    const mat = await getApi(
      `/energy_need/material_types?type=3&year=${submitData.construction_year}`
    );
    setMaterial(mat.data.data);
  };
  useEffect(() => {
    const {
      basement_detail,
      insulation_details,
      roof_detail,
      window_details,
      windowDimension,
      insulation,
      construction_year,
    } = state.needData;
    const updatedInsulation = insulation_details?.map((item) => {
      // Find the matching entry in insulationFields
      const matchingField = insulationFields.find(
        (field) => field.insulation_on === item.insulation_on
      );

      // If a match is found, add title and title_germ to the item
      if (matchingField) {
        return {
          ...item,
          title: matchingField.title,
          title_germ: matchingField.title_germ,
          length:
            language == "de"
              ? convertDotToComma(item.length)
              : convertCommaToDot(item.length),
        };
      }

      return item; // If no match found, return the original item
    });

    let new_window_details = state?.needData?.window_details;
    const result = updatedInsulation.some((item) => item.length !== 0);

    let have_dimensions = false;
    if (new_window_details && new_window_details.length > 0) {
      have_dimensions =
        new_window_details[0].is_dimension_available_for_every_window;
    }
    if (roof_detail && roof_detail.hasOwnProperty("id")) {
      const {
        roof_shape,
        construction,
        attic,
        is_attic_heated,
        roof_pitch,
        roof_height,
        is_there_second_attic,
        is_second_attic_heated,
        heating_percentage_of_second_attic,
        second_attic_height,
        does_property_have_knee_wall_or_seal,
        knee_wall,
        heating_percentage: heating_percentage_1,
        ridge_length,
        ridge_width,
      } = roof_detail;
      // const { windowDimension } = window_details;
      const {
        what_lies_below_ground_floor,
        ceiling_construction,
        heating_percentage,
      } = basement_detail;
      setRoofType(roof_shape);
      setSubmitData((prev) => ({
        ...prev,
        construction,
        attic,
        is_attic_heated: is_attic_heated === true ? 1 : 2,
        roof_pitch,
        roof_height:
          language == "de"
            ? convertDotToComma(roof_height ? roof_height.toString() : "")
            : roof_height,
        is_there_second_attic,
        is_second_attic_heated,
        heating_percentage_of_second_attic:
          language == "de"
            ? convertDotToComma(
                heating_percentage_of_second_attic
                  ? heating_percentage_of_second_attic.toString()
                  : ""
              )
            : roof_height,
        second_attic_height:
          language == "de"
            ? convertDotToComma(
                second_attic_height ? second_attic_height.toString() : ""
              )
            : roof_height,
        does_property_have_knee_wall_or_seal,
        knee_wall:
          language == "de"
            ? convertDotToComma(knee_wall)
            : convertCommaToDot(knee_wall),
        is_dimension_available_for_every_window: have_dimensions,
        what_lies_below_ground_floor,
        ceiling_construction,
        heating_percentage,
        insulation_details: updatedInsulation,
        insulation: result,
        heating_percentage_1:
          language == "de"
            ? convertDotToComma(
                heating_percentage_1 ? heating_percentage_1.toString() : ""
              )
            : roof_height,
        ridge_length:
          language == "de"
            ? convertDotToComma(ridge_length ? ridge_length.toString() : "")
            : ridge_length,
        ridge_width:
          language == "de"
            ? convertDotToComma(ridge_width ? ridge_width.toString() : "")
            : ridge_width,
        construction_year,
      }));
      // setWindowsNew((prev) => {
      //   const _data = prev.window_details;
      //   _data.push({
      //     attached_wall_id: attached_wall_id,
      //     is_dimension_available_for_every_window:
      //       is_dimension_available_for_every_window,
      //     count: null,
      //     length: null,
      //     width: null,
      //     window_type_id: null,
      //   });
      //   return { ...prev, window_details: _data };
      // });
    } else {
      setSubmitData((prev) => ({
        ...prev,
        construction_year,
      }));
    }
  }, [state.needData]);
  useEffect(() => {
    if (windows) {
      const result = Array.from({ length: windows }, (_, index) => {
        return { id: null, value: `Item ${index + 1}` };
      });
      const convertedArray = result.map((item) => ({
        window_type_id: item.id,
        length: null,
        width: null,
      }));
      setSubmitData((prev) => ({ ...prev, window_details: convertedArray }));
    } else {
      setSubmitData((prev) => ({ ...prev, window_details: [] }));
    }
  }, [windows]);
  const getData = async () => {
    try {
      const responseData = await getApi(`/energy_need/glazing_types/`);
      const responseRoof = await getApi(`/energy_need/roof_shapes/`);
      const matResponse = await getApi(
        `/energy_need/material_types?type=2&year=${state?.needData.construction_year}`
      );
      setGlazingData(responseData?.data?.data);
      setRoof(responseRoof.data.data);
      setStructure(matResponse.data.data);

      if (responseRoof?.data?.data && responseRoof?.data?.data?.length > 0) {
        if (
          state?.needData?.roof_detail?.hasOwnProperty("roof_shape") &&
          state?.needData?.roof_detail?.roof_shape.hasOwnProperty("id")
        ) {
        } else {
          setRoofType(responseRoof.data.data[0]);
        }
      }
      setDisableNext(false);
    } catch (error) {}
  };
  const handleClick = (item) => {
    setRoofType(item);
  };
  const handleChangeWindow = (e, index, type) => {
    const { name, value } = e.target;
    setWindowsNew((prev) => {
      const _data = prev.window_details;
      _data[index][name] = value;
      return { ...prev, window_details: _data };
    });
  };
  const handleAdd = (item) => {
    const { attached_wall_id, is_dimension_available_for_every_window } = item;
    setWindowsNew((prev) => {
      const _data = prev.window_details;
      _data.push({
        attached_wall_id: attached_wall_id,
        is_dimension_available_for_every_window:
          submitData.is_dimension_available_for_every_window,
        count: null,
        length: null,
        width: null,
        window_type_id: null,
      });
      return { ...prev, window_details: _data };
    });
  };

  const handleRemove = (pos) => {
    setWindowsNew((prev) => {
      const _data = [...prev.window_details]; // Create a copy of the array
      _data.splice(pos, 1); // Remove the item at the specified position
      return { ...prev, window_details: _data };
    });
  };

  const handlePopUp = (data) => {
    setPop(true);
    setInfoText(data);
  };
  const popData = {
    shape: [
      {
        heading: needLanguage.shape,
        para1: needLanguage.shape_info,
      },
    ],
    structure: [
      {
        heading: needLanguage.structure,
        para1: needLanguage.structure_info,
      },
    ],
    type: [
      {
        heading: needLanguage.type,
        para1: needLanguage.type_info,
      },
    ],
    length: [
      {
        heading: needLanguage.length,
        para1: needLanguage.length_info,

        // para3: needLanguage.building_d3,
      },
    ],
    width: [
      {
        heading: needLanguage.width,
        para1: needLanguage.width_info,
      },
    ],
    count: [
      {
        heading: needLanguage.count,
        para1: needLanguage.count_info,
      },
    ],
    window_type: [
      {
        heading: needLanguage.window_type,
        para1: needLanguage.window_type_info,
      },
    ],
    per_window: [
      {
        heading: needLanguage.per_window_info,
        para1: needLanguage.per_window_info,
      },
    ],
    under_1st: [
      {
        heading: needLanguage.under_1st,
        para1: needLanguage.under_1st_info1,
        para2: needLanguage.under_1st_info2,
      },
    ],
    slab: [
      {
        heading: needLanguage.slab,
        para1: needLanguage.slab_info,
      },
    ],
    insulated: [
      {
        heading: needLanguage.insulated,
        // para1: needLanguage.per_window_info,
      },
    ],
    ex_walls: [
      {
        heading: needLanguage.ex_walls,
        para1: needLanguage.ex_walls_info,
      },
    ],
    top_roof: [
      {
        heading: needLanguage.top_roof,
        para1: needLanguage.top_roof_info,
      },
    ],
    celler: [
      {
        heading: needLanguage.celler,
        para1: needLanguage.celler_info1,
        para1: needLanguage.celler_info2,
      },
    ],
    base_walls: [
      {
        heading: needLanguage.base_walls,
        para1: needLanguage.base_walls_info,
      },
    ],

    attic: [
      {
        heading: needLanguage.attic,
        para1: needLanguage.attic_info,
      },
    ],
    attic_type: [
      {
        heading: needLanguage.attic_type,
        para1: needLanguage.attic_type_info1,

        para2: needLanguage.attic_type_info2,
      },
    ],

    roof_p: [
      {
        heading: needLanguage.roof_p,
        para1: needLanguage.roof_p_info,
      },
    ],
    Attic_Height: [
      {
        heading: needLanguage.Attic_Height,
        para1: needLanguage.Attic_Height_info1,
        para2: needLanguage.Attic_Height_info2,
        para3: needLanguage.Attic_Height_info3,
      },
    ],
    sec_attic: [
      {
        heading: needLanguage.sec_attic,
        para1: needLanguage.sec_attic_info,
      },
    ],
    sec_attic_heat: [
      {
        heading: needLanguage.sec_attic_heat,
        para1: needLanguage.sec_attic_heat_info,
      },
    ],
    sec_attic_per: [
      {
        heading: needLanguage.sec_attic_per,
        para1: needLanguage.sec_attic_per_info,
      },
    ],
    sec_attic_height: [
      {
        heading: needLanguage.sec_attic_height,
        para1: needLanguage.sec_attic_height_info,
      },
    ],
    sill: [
      {
        heading: needLanguage.sill,
        para1: needLanguage.sill_info,
        para1: needLanguage.celler_info2,
      },
    ],
    sill_height: [
      {
        heading: needLanguage.sill_height,
      },
    ],
    window_install_year: [
      {
        heading: needLanguage.window_install_year,
      },
    ],
  };
  return (
    <div>
      <div className={styles.con}>
        <StepsHeader
          image={buildingComponent}
          heading={needLanguage.building_component}
          secPara={needLanguage.provided_information}
        />
        <div className={styles.fieldDetails}>
          <BuildingTabs type={type} setType={setType} />
          <p style={{ color: "#d32f2f" }}>{errorsData.error}</p>

          {type === 1 && (
            <div>
              <p className={styles.fieldName}>
                {needLanguage.roof_shape}
                <img
                  src={info}
                  style={{ cursor: "pointer" }}
                  onClick={() => handlePopUp(popData?.shape)}
                />
              </p>

              <div
                className={styles.shapes}
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                {roof.map((item, index) => {
                  return (
                    <div
                      style={{
                        background: "#AFDB2840",
                        display: "flex",
                        padding: "8px",
                        borderRadius: "10px",
                        alignItems: "center",
                        border: `${
                          item.id === roofType?.id
                            ? "2px solid #22A156"
                            : "2px solid white"
                        }`,
                        cursor: "pointer",
                      }}
                      onClick={() => handleClick(item)}
                    >
                      <img
                        src={item.image}
                        style={{ marginRight: "10px", minWidth: "65px" }}
                      />
                      <p style={{ margin: "0px" }}>
                        {selectedLanguage(item, language)}
                      </p>
                    </div>
                  );
                })}
              </div>
              <div>
                <div>
                  <div className={styles.fieldCom}>
                    <div className={styles.fields}>
                      <p className={styles.fieldName}>
                        {needLanguage.structure}
                        <img
                          src={info}
                          style={{ cursor: "pointer" }}
                          onClick={() => handlePopUp(popData?.structure)}
                        />
                      </p>
                      <FormControl
                        fullWidth
                        error={Boolean(errorsData.construction)}
                      >
                        <Select
                          size="small"
                          // value={submitData.material_id}
                          name="construction"
                          value={submitData.construction ?? ""}
                          onChange={(e) => handleChange(e)}
                        >
                          {structure.map((option) => (
                            <MenuItem key={option.id} value={option.id}>
                              {selectedLanguage(option, language)}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      {errorsData?.construction && (
                        <FormHelperText error={errorsData.construction}>
                          {errorsData?.construction}
                        </FormHelperText>
                      )}
                    </div>
                    {roofType?.is_attic_required && (
                      <>
                        <div className={styles.fields}>
                          <p className={styles.fieldName}>
                            {needLanguage.attic}
                            <img
                              src={info}
                              style={{ cursor: "pointer" }}
                              onClick={() => handlePopUp(popData?.attic)}
                            />
                          </p>
                          <FormControl
                            fullWidth
                            error={Boolean(errorsData.attic)}
                          >
                            <Select
                              size="small"
                              // value={submitData.material_id}
                              name="attic"
                              value={submitData.attic ?? ""}
                              onChange={(e) => handleChange(e)}
                            >
                              {atticTypes.map((option) => (
                                <MenuItem key={option.id} value={option.id}>
                                  {selectedLanguage(option, language)}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                          {errorsData?.attic && (
                            <FormHelperText error={errorsData.attic}>
                              {errorsData?.attic}
                            </FormHelperText>
                          )}
                        </div>
                        <div className={styles.fields}>
                          <p className={styles.fieldName}>
                            {needLanguage.attic_type}
                            <img
                              src={info}
                              style={{ cursor: "pointer" }}
                              onClick={() => handlePopUp(popData?.attic_type)}
                            />
                          </p>
                          <FormControl
                            fullWidth
                            error={Boolean(errorsData.is_attic_heated)}
                          >
                            <Select
                              size="small"
                              // value={submitData.material_id}
                              name="is_attic_heated"
                              value={submitData.is_attic_heated ?? ""}
                              onChange={(e) => handleChange(e)}
                              submitData
                            >
                              {booleanValue.map((option) => (
                                <MenuItem key={option.id} value={option.id}>
                                  {selectedLanguage(option, language)}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                          {errorsData?.is_attic_heated && (
                            <FormHelperText error={errorsData.is_attic_heated}>
                              {errorsData?.is_attic_heated}
                            </FormHelperText>
                          )}
                        </div>
                        <div className={styles.fields}>
                          <p className={styles.fieldName}>
                            {needLanguage.roof_pitch}
                            <img
                              src={info}
                              style={{ cursor: "pointer" }}
                              onClick={() => handlePopUp(popData?.roof_p)}
                            />
                          </p>
                          <FormControl
                            fullWidth
                            error={Boolean(errorsData.roof_pitch)}
                          >
                            <Select
                              size="small"
                              // value={submitData.material_id}
                              name="roof_pitch"
                              value={submitData.roof_pitch ?? ""}
                              onChange={(e) => handleChange(e)}
                            >
                              {degreeArr.map((option) => (
                                <MenuItem key={option.id} value={option.id}>
                                  {option.title}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                          {errorsData?.roof_pitch && (
                            <FormHelperText error={errorsData.roof_pitch}>
                              {errorsData?.roof_pitch}
                            </FormHelperText>
                          )}
                        </div>

                        <div className={styles.fields}>
                          <p className={styles.fieldName}>
                            {needLanguage.attic_height}
                            <img
                              src={info}
                              style={{ cursor: "pointer" }}
                              onClick={() => handlePopUp(popData?.Attic_Height)}
                            />
                          </p>
                          <TextField
                            style={{ width: "100%" }}
                            size="small"
                            name="roof_height"
                            onChange={(e) => handleChange(e)}
                            value={submitData.roof_height}
                            onWheel={(e) => e.target.blur()}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  m
                                </InputAdornment>
                              ),
                            }}
                            error={errorsData?.roof_height}
                            helperText={errorsData?.roof_height}
                          />
                        </div>

                        {roofType?.id === 5 && (
                          <React.Fragment>
                            <div className={styles.fields}>
                              <p className={styles.fieldName}>
                                {needLanguage.ridge_length}
                              </p>
                              <TextField
                                style={{ width: "100%" }}
                                size="small"
                                name="ridge_length"
                                onChange={(e) => handleChange(e)}
                                value={submitData.ridge_length}
                                onWheel={(e) => e.target.blur()}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      m
                                    </InputAdornment>
                                  ),
                                }}
                                error={errorsData?.ridge_length}
                                helperText={errorsData?.ridge_length}
                              />
                            </div>

                            <div className={styles.fields}>
                              <p className={styles.fieldName}>
                                {" "}
                                {needLanguage.ridge_width}
                              </p>
                              <TextField
                                style={{ width: "100%" }}
                                size="small"
                                name="ridge_width"
                                onChange={(e) => handleChange(e)}
                                value={submitData.ridge_width}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      m
                                    </InputAdornment>
                                  ),
                                }}
                                error={errorsData?.ridge_width}
                                helperText={errorsData?.ridge_width}
                              />
                            </div>
                          </React.Fragment>
                        )}
                        {submitData.is_attic_heated === 1 && (
                          <div className={styles.fields}>
                            <p className={styles.fieldName}>
                              {needLanguage.heating_percentage}
                            </p>
                            <TextField
                              style={{ width: "100%" }}
                              size="small"
                              name="heating_percentage_1"
                              onChange={(e) => handleChange(e)}
                              value={submitData.heating_percentage_1}
                              error={errorsData?.heating_percentage_1}
                              helperText={errorsData?.heating_percentage_1}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    %
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
              {roofType?.id !== 3 && (
                <Fragment>
                  {roofType?.id === 1 && (
                    <div className={styles.fieldDetailsCon}>
                      <p className={styles.fieldName}>
                        {needLanguage.is_there_second_attic}
                        <img
                          src={info}
                          style={{ cursor: "pointer" }}
                          onClick={() => handlePopUp(popData?.sec_attic)}
                        />
                      </p>
                      <RadioGroup
                        name="is_there_second_attic" // Name of the radio group
                        value={submitData.is_there_second_attic} // Bind the state value
                        onChange={(e) => handleChange(e)}
                      >
                        <div className={styles.Radio}>
                          <FormControlLabel
                            value={true}
                            control={<Radio />}
                            label={needLanguage.yes}
                          />
                          <FormControlLabel
                            value={false}
                            control={<Radio />}
                            label={needLanguage.no}
                          />
                        </div>
                      </RadioGroup>

                      {(submitData.is_there_second_attic == true ||
                        submitData.is_there_second_attic == "true") && (
                        <div>
                          <p className={styles.fieldName}>
                            {needLanguage.is_there_second_attic_heated}
                            <img
                              src={info}
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                handlePopUp(popData?.sec_attic_heat)
                              }
                            />
                          </p>
                          <RadioGroup
                            name="is_second_attic_heated" // Name of the radio group
                            value={submitData.is_second_attic_heated} // Bind the state value
                            onChange={(e) => handleChange(e)}
                          >
                            <div className={styles.Radio}>
                              <FormControlLabel
                                value={true}
                                control={<Radio />}
                                label={needLanguage.yes}
                              />
                              <FormControlLabel
                                value={false}
                                control={<Radio />}
                                label={needLanguage.no}
                              />
                            </div>
                          </RadioGroup>
                          <div className={styles.fieldCom}>
                            {submitData.is_second_attic_heated && (
                              <div className={styles.fields}>
                                <p className={styles.fieldName}>
                                  {needLanguage.heated_percentage_second}
                                  <img
                                    src={info}
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                      handlePopUp(popData?.sec_attic_per)
                                    }
                                  />
                                </p>
                                <TextField
                                  style={{ width: "100%" }}
                                  size="small"
                                  name="heating_percentage_of_second_attic"
                                  onChange={(e) => handleChange(e)}
                                  value={
                                    submitData.heating_percentage_of_second_attic
                                  }
                                  error={
                                    errorsData?.heating_percentage_of_second_attic
                                  }
                                  helperText={
                                    errorsData?.heating_percentage_of_second_attic
                                  }
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        %
                                      </InputAdornment>
                                    ),
                                  }}
                                />
                              </div>
                            )}
                            <div className={styles.fields}>
                              <p className={styles.fieldName}>
                                {needLanguage.second_attic_height}
                                <img
                                  src={info}
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    handlePopUp(popData?.sec_attic_height)
                                  }
                                />
                              </p>{" "}
                              <TextField
                                style={{ width: "100%" }}
                                size="small"
                                name="second_attic_height"
                                onChange={(e) => handleChange(e)}
                                value={submitData.second_attic_height}
                                error={errorsData?.second_attic_height}
                                helperText={errorsData?.second_attic_height}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      m
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                  <div className={styles.fieldDetailsCon}>
                    <p className={styles.fieldName}>
                      {needLanguage.knee_wall_or_sill}
                      <img
                        src={info}
                        style={{ cursor: "pointer" }}
                        onClick={() => handlePopUp(popData?.sill)}
                      />
                    </p>
                    <RadioGroup
                      name="does_property_have_knee_wall_or_seal" // Name of the radio group
                      value={submitData.does_property_have_knee_wall_or_seal} // Bind the state value
                      onChange={(e) => handleChange(e)}
                    >
                      <div className={styles.Radio}>
                        <FormControlLabel
                          value={true}
                          control={<Radio />}
                          label={needLanguage.yes}
                        />
                        <FormControlLabel
                          value={false}
                          control={<Radio />}
                          label={needLanguage.no}
                        />
                      </div>
                    </RadioGroup>

                    {(submitData.does_property_have_knee_wall_or_seal == true ||
                      submitData.does_property_have_knee_wall_or_seal ==
                        "true") && (
                      <div>
                        <p className={styles.fieldName}>
                          {needLanguage.knee_wall_sill_height}
                          <img
                            src={info}
                            style={{ cursor: "pointer" }}
                            onClick={() => handlePopUp(popData?.sill_height)}
                          />
                        </p>
                        <TextField
                          name="knee_wall"
                          onChange={handleChange}
                          value={submitData.knee_wall}
                          error={errorsData?.knee_wall}
                          helperText={errorsData?.knee_wall}
                          size="small"
                          style={{ width: "100%" }}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">m</InputAdornment>
                            ),
                          }}
                        />
                      </div>
                    )}
                  </div>
                </Fragment>
              )}
            </div>
          )}
          {type === 2 && (
            <div>
              {structType == 5 ? (
                <div
                  style={{
                    marginTop: "50px",
                    textAlign: "center",
                  }}
                >
                  <p style={{ fontSize: "20px", fontWeight: "500" }}>
                    {needLanguage.no_wall}
                  </p>
                </div>
              ) : (
                <div>
                  <div className={styles.fieldCom}>
                    <div
                      style={{
                        background: "#AFDB2840",
                        marginTop: "15px",
                        padding: "10px",
                        borderRadius: "10px",
                        width: "100%",
                      }}
                      className={styles.fullWidthcon}
                    >
                      <p>{needLanguage.window_top_para_1}</p>
                    </div>
                    <div style={{ width: "100%" }}>
                      <div className={styles.yearField}>
                        <div style={{ marginRight: "25px" }}>
                          <p className={styles.fieldName}>
                            {needLanguage.have_dimensions_window}
                          </p>
                          <RadioGroup
                            name="is_dimension_available_for_every_window" // Name of the radio group
                            value={
                              submitData.is_dimension_available_for_every_window
                            } // Bind the state value
                            onChange={(e) => handleChange(e)}
                          >
                            <div className={styles.Radio}>
                              <FormControlLabel
                                value={true}
                                control={<Radio />}
                                label={needLanguage.yes}
                              />
                              <FormControlLabel
                                value={false}
                                control={<Radio />}
                                label={needLanguage.no}
                              />
                            </div>
                          </RadioGroup>
                        </div>
                        <div className={styles.fields}>
                          <p className={styles.fieldName}>
                            {needLanguage?.window_year}
                            <img
                              src={info}
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                handlePopUp(popData?.window_install_year)
                              }
                            />
                          </p>
                          <TextField
                            size="small"
                            style={{
                              width: "90%",
                              marginRight: "15px",
                            }}
                            onWheel={(e) => e.target.blur()}
                            name="construction_year"
                            value={submitData.construction_year}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div
                        style={{
                          background: "#AFDB2840",
                          marginTop: "15px",
                          padding: "10px",
                          borderRadius: "10px",
                        }}
                      >
                        <p className={styles.fieldName}>
                          {needLanguage.windows_in_wall}{" "}
                          {indexToAlphabet(windowsNew?.active?.index)}
                        </p>
                        <p style={{ lineHeight: "24px" }}>
                          {submitData.is_dimension_available_for_every_window
                            ? needLanguage.window_top_para_2
                            : needLanguage.window_top_para_3}{" "}
                        </p>
                      </div>
                      <div className={styles.windowsData}>
                        {windowsNew?.wall_details?.map((item, index) => {
                          const value = item.length ? item.length : "";
                          const letter = String.fromCharCode(65 + index); // 65 is the ASCII code for 'A'
                          return (
                            <div
                              style={{
                                // background: `${
                                //   windowsNew?.active?.id === item.id
                                //     ? "#22A156"
                                //     : "white"
                                // }`,
                                color: `${
                                  windowsNew?.active?.id !== item.id
                                    ? "#22A156"
                                    : "white"
                                }`,
                                cursor: "pointer",
                                marginRight: "10px",
                                borderRadius: "10px",
                              }}
                              onClick={() => {
                                setWindowsNew((prev) => ({
                                  ...prev,
                                  active: item,
                                }));
                              }}
                            >
                              {/* <p style={{ margin: "0px" }}>
                            {" "}
                            {needLanguage.wall} {letter}
                          </p> */}
                              <img
                                src={item.image}
                                style={{
                                  width: "100px",
                                  border: `${
                                    windowsNew?.active?.id === item.id
                                      ? "1px solid #22a156"
                                      : "1px solid white"
                                  }`,
                                  padding: "10px",
                                  borderRadius: "10px",
                                  boxShadow: `${
                                    windowsNew?.active?.id === item.id
                                      ? "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px"
                                      : ""
                                  }`,
                                }}
                              />
                            </div>
                          );
                        })}
                      </div>
                      {!submitData.is_dimension_available_for_every_window ? (
                        <div>
                          {windowsNew.window_details?.map((item, index) => {
                            if (windowsNew?.active?.id == item.attached_wall_id)
                              return (
                                <div className={styles.fieldCom}>
                                  <div className={styles.fields}>
                                    <p className={styles.fieldName}>
                                      {needLanguage.window_type}
                                      <img
                                        src={info}
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          handlePopUp(popData?.window_type)
                                        }
                                      />
                                    </p>
                                    <FormControl
                                      fullWidth
                                      error={Boolean(
                                        errorWindow[index]?.window_type_id
                                      )}
                                    >
                                      <Select
                                        size="small"
                                        // value={submitData.material_id}
                                        name="window_type_id"
                                        value={item.window_type_id ?? ""}
                                        style={{
                                          width: "100%",

                                          marginRight: "15px",
                                        }}
                                        onChange={(e) =>
                                          handleChangeWindow(e, index)
                                        }
                                      >
                                        {material.map((option) => (
                                          <MenuItem
                                            key={option.id}
                                            value={option.id}
                                          >
                                            {selectedLanguage(option, language)}
                                          </MenuItem>
                                        ))}
                                      </Select>
                                    </FormControl>
                                    {errorWindow[index]?.window_type_id && (
                                      <FormHelperText
                                        error={
                                          errorWindow[index]?.window_type_id
                                        }
                                      >
                                        {errorWindow[index]?.window_type_id}
                                      </FormHelperText>
                                    )}
                                  </div>
                                  <div className={styles.fields}>
                                    <p className={styles.fieldName}>
                                      {needLanguage.window_area_wall}
                                      <img
                                        src={info}
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          handlePopUp(popData?.per_window)
                                        }
                                      />
                                    </p>
                                    <TextField
                                      value={
                                        item.percentage_of_window_area_on_the_wall
                                      }
                                      onChange={(e) =>
                                        handleChangeWindow(e, index)
                                      }
                                      name="percentage_of_window_area_on_the_wall"
                                      size="small"
                                      // style={{ minWidth: "400px" }}
                                      style={{ width: "100%" }}
                                      error={
                                        errorWindow[index]
                                          ?.percentage_of_window_area_on_the_wall ==
                                        0
                                          ? ""
                                          : errorWindow[index]
                                              ?.percentage_of_window_area_on_the_wall
                                      }
                                      helperText={
                                        errorWindow[index]
                                          ?.percentage_of_window_area_on_the_wall ==
                                        0
                                          ? ""
                                          : errorWindow[index]
                                              ?.percentage_of_window_area_on_the_wall
                                      }
                                      onWheel={(e) => e.target.blur()}
                                      InputProps={{
                                        endAdornment: (
                                          <InputAdornment position="end">
                                            %
                                          </InputAdornment>
                                        ),
                                      }}
                                    />
                                  </div>
                                </div>
                              );
                          })}
                        </div>
                      ) : (
                        <div>
                          <div className={styles.addedFields}>
                            {windowsNew.window_details?.map((item, index) => {
                              if (index === 0) view_count = 0;
                              if (
                                windowsNew?.active?.id == item.attached_wall_id
                              ) {
                                let disableRemove =
                                  view_count === 0 ? true : false;
                                view_count++;
                                return (
                                  <div style={{ display: "flex" }}>
                                    <div>
                                      <p className={styles.fieldName}>
                                        {needLanguage.type}
                                        <img
                                          src={info}
                                          style={{ cursor: "pointer" }}
                                          onClick={() =>
                                            handlePopUp(popData?.type)
                                          }
                                        />
                                      </p>
                                      <FormControl
                                        fullWidth
                                        error={Boolean(
                                          errorWindow[index]?.window_type_id
                                        )}
                                      >
                                        <Select
                                          size="small"
                                          // value={submitData.material_id}
                                          name="window_type_id"
                                          value={item.window_type_id ?? ""}
                                          style={{
                                            width: "300px",
                                            marginRight: "15px",
                                          }}
                                          onChange={(e) =>
                                            handleChangeWindow(e, index)
                                          }
                                        >
                                          {material.map((option) => (
                                            <MenuItem
                                              key={option.id}
                                              value={option.id}
                                            >
                                              {selectedLanguage(
                                                option,
                                                language
                                              )}
                                            </MenuItem>
                                          ))}
                                        </Select>
                                      </FormControl>
                                      {errorWindow[index]?.window_type_id && (
                                        <FormHelperText
                                          error={
                                            errorWindow[index]?.window_type_id
                                          }
                                        >
                                          {errorWindow[index]?.window_type_id}
                                        </FormHelperText>
                                      )}
                                    </div>
                                    <div>
                                      <p className={styles.fieldName}>
                                        {needLanguage.length}
                                        <img
                                          src={info}
                                          style={{ cursor: "pointer" }}
                                          onClick={() =>
                                            handlePopUp(popData?.length)
                                          }
                                        />
                                      </p>
                                      <TextField
                                        name="length"
                                        value={item.length}
                                        size="small"
                                        style={{
                                          width: "200px",
                                          marginRight: "15px",
                                        }}
                                        onChange={(e) =>
                                          handleChangeWindow(e, index)
                                        }
                                        InputProps={{
                                          endAdornment: (
                                            <InputAdornment position="end">
                                              m
                                            </InputAdornment>
                                          ),
                                        }}
                                        error={errorWindow[index]?.length}
                                        helperText={errorWindow[index]?.length}
                                      />
                                    </div>
                                    <div>
                                      <p className={styles.fieldName}>
                                        {" "}
                                        {needLanguage.width}
                                        <img
                                          src={info}
                                          style={{ cursor: "pointer" }}
                                          onClick={() =>
                                            handlePopUp(popData?.width)
                                          }
                                          InputProps={{
                                            endAdornment: (
                                              <InputAdornment position="end">
                                                m
                                              </InputAdornment>
                                            ),
                                          }}
                                        />
                                      </p>
                                      <TextField
                                        name="width"
                                        value={item.width}
                                        size="small"
                                        style={{
                                          width: "200px",
                                          marginRight: "15px",
                                        }}
                                        onChange={(e) =>
                                          handleChangeWindow(e, index)
                                        }
                                        InputProps={{
                                          endAdornment: (
                                            <InputAdornment position="end">
                                              m
                                            </InputAdornment>
                                          ),
                                        }}
                                        error={errorWindow[index]?.width}
                                        helperText={errorWindow[index]?.width}
                                      />
                                    </div>
                                    <div>
                                      <p className={styles.fieldName}>
                                        {needLanguage.count}
                                        <img
                                          src={info}
                                          style={{ cursor: "pointer" }}
                                          onClick={() =>
                                            handlePopUp(popData?.count)
                                          }
                                        />
                                      </p>
                                      <TextField
                                        name="count"
                                        value={item.count}
                                        size="small"
                                        style={{
                                          width: "200px",
                                          marginRight: "15px",
                                        }}
                                        onChange={(e) =>
                                          handleChangeWindow(e, index)
                                        }
                                        error={errorWindow[index]?.count}
                                        helperText={errorWindow[index]?.count}
                                      />
                                    </div>
                                    <div style={{ marginRight: "10px" }}>
                                      <p className={styles.fieldName}>&nbsp;</p>
                                      <Button
                                        variant="contained"
                                        onClick={() => handleRemove(index)}
                                        disabled={disableRemove}
                                      >
                                        -
                                      </Button>
                                    </div>
                                    <div>
                                      <p className={styles.fieldName}>&nbsp;</p>
                                      <Button
                                        variant="contained"
                                        onClick={() => handleAdd(item)}
                                      >
                                        +
                                      </Button>
                                    </div>
                                  </div>
                                );
                              }
                            })}
                          </div>
                        </div>
                      )}

                      {/* <div>
                    <TextField
                      size="small"
                      style={{ width: "100%" }}
                      onChange={(e) => {
                        setWindows(e.target.value);
                      }}
                    />
                  </div> */}
                      <div className={styles.fields}>
                        {}
                        {/* {submitData.window_details.map((item, index) => {
                      return (
                        <div style={{ display: "flex" }}>
                          <div>
                            <p className={styles.fieldName}>Type</p>
                            <div>
                              <FormControl fullWidth>
                                <Select
                                  size="small"
                                  // value={submitData.material_id}
                                  name="window_type_id"
                                  value={item.window_type_id}
                                  onChange={(e) => handleChangeIndex(e, index)}
                                  style={{
                                    width: "300px",
                                    marginRight: "15px",
                                  }}
                                >
                                  {glazingData.map((option) => (
                                    <MenuItem key={option.id} value={option.id}>
                                      {option.title}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </div>
                          </div>
                          <div>
                            <p className={styles.fieldName}>Length</p>
                            <TextField
                              name="length"
                              value={item.length}
                              size="small"
                              style={{ width: "200px", marginRight: "15px" }}
                              onChange={(e) => handleChangeIndex(e, index)}
                            />
                          </div>
                          <div>
                            <p className={styles.fieldName}>Width</p>
                            <TextField
                              name="width"
                              value={item.width}
                              size="small"
                              style={{ width: "200px", marginRight: "15px" }}
                              onChange={(e) => handleChangeIndex(e, index)}
                            />
                          </div>
                        </div>
                      );
                    })} */}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
          {type === 3 && (
            <div>
              <div className={styles.fieldCom}>
                <div className={styles.fields}>
                  <p className={styles.fieldName}>
                    {needLanguage.below_ground_floor}
                    <img
                      src={info}
                      style={{ cursor: "pointer" }}
                      onClick={() => handlePopUp(popData?.under_1st)}
                    />
                  </p>
                  <FormControl
                    fullWidth
                    error={Boolean(errorsData.what_lies_below_ground_floor)}
                  >
                    <Select
                      size="small"
                      // value={submitData.material_id}
                      name="what_lies_below_ground_floor"
                      value={submitData.what_lies_below_ground_floor ?? ""}
                      onChange={(e) => handleChange(e)}
                    >
                      {belowGroundFloor.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                          {selectedLanguage(option, language)}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  {errorsData?.what_lies_below_ground_floor && (
                    <FormHelperText
                      error={errorsData.what_lies_below_ground_floor}
                    >
                      {errorsData?.what_lies_below_ground_floor}
                    </FormHelperText>
                  )}
                </div>
                <div className={styles.fields}>
                  <p className={styles.fieldName}>
                    {needLanguage.floor_slab}
                    <img
                      src={info}
                      style={{ cursor: "pointer" }}
                      onClick={() => handlePopUp(popData?.slab)}
                    />
                  </p>
                  <FormControl
                    fullWidth
                    error={Boolean(errorsData.ceiling_construction)}
                  >
                    <Select
                      size="small"
                      // value={submitData.material_id}
                      name="ceiling_construction"
                      value={submitData.ceiling_construction ?? ""}
                      onChange={(e) => handleChange(e)}
                    >
                      {celingConstructionType.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                          {selectedLanguage(option, language)}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  {errorsData?.ceiling_construction && (
                    <FormHelperText error={errorsData.ceiling_construction}>
                      {errorsData?.ceiling_construction}
                    </FormHelperText>
                  )}
                </div>
                {submitData.what_lies_below_ground_floor == "2" && (
                  <div className={styles.fields}>
                    <p className={styles.fieldName}>
                      {needLanguage.heated_part_basement}
                    </p>

                    <FormControl
                      fullWidth
                      error={Boolean(errorsData.heating_percentage)}
                    >
                      <Select
                        size="small"
                        // value={submitData.material_id}
                        name="heating_percentage"
                        value={submitData.heating_percentage ?? ""}
                        onChange={(e) => handleChange(e)}
                      >
                        {heatedPercent.map((option) => (
                          <MenuItem key={option.id} value={option.id}>
                            {selectedLanguage(option, language)}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    {errorsData?.heating_percentage && (
                      <FormHelperText error={errorsData.heating_percentage}>
                        {errorsData?.heating_percentage}
                      </FormHelperText>
                    )}
                  </div>
                )}
              </div>
            </div>
          )}
          {type === 4 && (
            <div>
              <div className={styles.fieldCon}>
                <p className={styles.fieldName}>
                  {needLanguage.property_insulated}
                  {/* <img
                    src={info}
                    style={{ cursor: "pointer" }}
                    onClick={() => handlePopUp(popData?.insulated)}
                  /> */}
                </p>
                <RadioGroup
                  name="insulation" // Name of the radio group
                  value={submitData.insulation} // Bind the state value
                  onChange={handleChange} // Handle value changes
                >
                  <div className={styles.Radio}>
                    <FormControlLabel
                      value={true}
                      control={<Radio />}
                      label={needLanguage.yes}
                    />
                    <FormControlLabel
                      value={false}
                      control={<Radio />}
                      label={needLanguage.no}
                    />
                  </div>
                </RadioGroup>
                {(submitData.insulation == "true" || submitData.insulation) && (
                  <div>
                    {submitData.insulation_details.map((item, index) => {
                      return (
                        <div className={styles.fields}>
                          <p className={styles.fieldName}>
                            {language == "en" ? item.title : item?.title_germ}

                            <img
                              src={info}
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                handlePopUp(
                                  item.insulation_on == 1
                                    ? popData?.ex_walls
                                    : item.insulation_on == 2
                                    ? popData?.top_roof
                                    : item.insulation_on == 3
                                    ? popData?.celler
                                    : item.insulation_on == 4
                                    ? popData?.base_walls
                                    : ""
                                )
                              }
                            />
                          </p>
                          <TextField
                            style={{ width: "100%" }}
                            size="small"
                            showInfo={false}
                            name="length"
                            endIcon="cm"
                            onChange={(e) => handleChangeInsulation(e, index)}
                            value={item.length}
                            error={
                              errorsData?.insulation_details &&
                              errorsData?.insulation_details[index]
                            }
                            helperText={
                              errorsData?.insulation_details &&
                              errorsData?.insulation_details[index]
                            }
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  cm
                                </InputAdornment>
                              ),
                            }}
                          />
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
      <NavButton
        handleSubmit={handleSubmit}
        response={response}
        setResponse={setResponse}
        disabled={disableNext}
      />

      {pop && (
        <PopUpInfo
          handleClose={() => setPop(false)}
          open={pop}
          data={infoText}
        />
      )}
    </div>
  );
}

export default Step3;
